import { useSelector } from 'react-redux';
import { BooleanParam, StringParam, useQueryParams } from 'use-query-params';

import { ApplicationStatus } from '../../../common/constants';
import { ReactQueryKeys } from '../../../common/react-query-keys';
import { getSessionCompanyId } from '../../../selectors/session';
import { ChannelQueryParam } from '../constants';
import {
  ALL_APPLICATION_STATUSES,
  FilterApplicationSourceQueryParam,
  FilterApplicationStatusQueryParam,
} from '../queryParams';

export default function useGetChannelListParams() {
  const sessionCompanyId = useSelector(getSessionCompanyId);
  const [{ job_id, keyword, sort_by_unread, app_source, app_status }] =
    useQueryParams({
      [ChannelQueryParam.JOB_ID]: StringParam,
      [ChannelQueryParam.KEYWORD]: StringParam,
      [ChannelQueryParam.SORT_BY_UNREAD]: BooleanParam,
      [ChannelQueryParam.APP_SOURCE]: FilterApplicationSourceQueryParam,
      [ChannelQueryParam.APP_STATUS]: FilterApplicationStatusQueryParam,
    });

  const appStatusForApi =
    app_status === ALL_APPLICATION_STATUSES
      ? undefined
      : (app_status as ApplicationStatus);

  const params = {
    jobId: job_id || undefined,
    keyword: keyword || undefined,
    sortByUnread: Boolean(sort_by_unread),
    appSource: app_source,
    appStatus: appStatusForApi,
  };

  return {
    queryKey: ReactQueryKeys.channelList(params, sessionCompanyId),
    params,
  };
}
